<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M4.5 12a7.5 7.5 0 0 1 .104-1.244l-1.63-1.269a.75.75 0 0 1-.182-.977l1.5-2.598a.75.75 0 0 1 .914-.329l1.92.768a7.5 7.5 0 0 1 2.156-1.245l.287-2.043A.75.75 0 0 1 10.31 2.4h3a.75.75 0 0 1 .742.663l.287 2.043a7.5 7.5 0 0 1 2.156 1.245l1.92-.768a.75.75 0 0 1 .914.33l1.5 2.597a.75.75 0 0 1-.182.977l-1.63 1.269A7.5 7.5 0 0 1 19.5 12c0 .42-.035.832-.104 1.244l1.63 1.269a.75.75 0 0 1 .182.977l-1.5 2.598a.75.75 0 0 1-.914.329l-1.92-.768a7.5 7.5 0 0 1-2.156 1.245l-.287 2.043a.75.75 0 0 1-.742.663h-3a.75.75 0 0 1-.742-.663l-.287-2.043a7.5 7.5 0 0 1-2.156-1.245l-1.92.768a.75.75 0 0 1-.914-.33l-1.5-2.597a.75.75 0 0 1 .182-.977l1.63-1.269A7.5 7.5 0 0 1 4.5 12Z"
    />
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: "IconCog",
}
</script>
